import React, { useState, useEffect } from 'react';

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleResize = () => {
    setIsMobileView(window.innerWidth <= 768);
    if (window.innerWidth > 768) {
      setIsMobileMenuOpen(false); 
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav style={styles.nav}>
  
      <div style={styles.logo}>
        Soul<span style={styles.logo1}>Travel</span>.
      </div>

      {isMobileView && (
        <button style={styles.menuButton} onClick={toggleMenu}>
          ☰
        </button>
      )}

      <ul
        style={{
          ...styles.navLinks,
          display: isMobileView ? (isMobileMenuOpen ? 'block' : 'none') : 'flex',
          flexDirection: isMobileView && isMobileMenuOpen ? 'column' : 'row',
          alignItems: isMobileView && isMobileMenuOpen ? 'flex-start' : 'center',
          justifyContent: isMobileView && isMobileMenuOpen ? 'flex-start' : 'center', 
          position: isMobileView && isMobileMenuOpen ? 'absolute' : 'static',
          top: isMobileView && isMobileMenuOpen ? '60px' : 'auto',
          left: isMobileView && isMobileMenuOpen ? '0' : 'auto',
          width: isMobileView && isMobileMenuOpen ? '100%' : 'auto',
          backgroundColor: isMobileView && isMobileMenuOpen ? 'white' : 'transparent',
          boxShadow: isMobileView && isMobileMenuOpen ? '0 4px 6px rgba(0, 0, 0, 0.1)' : 'none',
        }}
      >
        <li style={styles.navItem}>
          <a href="#Destination" style={styles.navLink}>
            Destination
          </a>
        </li>
        <li style={styles.navItem}>
          <a href="#Package" style={styles.navLink}>
            Package
          </a>
        </li>
        <li style={styles.navItem}>
          <a href="#Blog" style={styles.navLink}>
            Blog
          </a>
        </li>
        <li style={styles.navItem}>
          <a href="#About Us" style={styles.navLink}>
            About Us
          </a>
        </li>
        <li style={styles.navItem}>
          <a href="#contact" style={styles.navLink}>
            Contact
          </a>
        </li>
      </ul>

      {!isMobileView && (
        <div style={styles.buttons}>
          <button style={styles.button} onClick={() => alert('Sign up Clicked!')}>
            Sign up
          </button>
          <button style={styles.button2} onClick={() => alert('Sign in Clicked!')}>
            Sign in
          </button>
        </div>
      )}
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1rem 2rem',
    backgroundColor: 'white',
    color: 'black',
    position: 'relative',
    
  },
  logo: {
    fontSize: '36px',
    fontWeight: 'bold',
  },
  logo1: {
    color: '#F77A40',
  },
  navLinks: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    alignItems: 'center',
    flex: 1,
      justifyContent: 'center', 
      },
  navItem: {
    fontSize: '18px',
    fontWeight: '400',
    padding: '1rem',
  },
  navLink: {
    textDecoration: 'none',
    color: 'black',
    transition: 'color 0.3s',
  },
  buttons: {
    display: 'flex',
    gap: '1rem',
  },
  button: {
    padding: '0.5rem 1rem',
    backgroundColor: 'white',
    color: '#282c34',
    border:'none',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.3s',
  },
  button2: {
    padding: '0.5rem 1rem',
    backgroundColor: '#F77A40',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '1rem',
    transition: 'background-color 0.3s',
  },
  menuButton: {
    display: 'block',
    backgroundColor: 'transparent',
    border: 'none',
    fontSize: '1.5rem',
    cursor: 'pointer',
    zIndex: 1001, 
  },
};

export default Navbar;
